function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScShare = function SvgScShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M7.87626 10.6379C7.41719 9.86801 6.58074 9.35294 5.625 9.35294C4.17525 9.35294 3 10.5381 3 12C3 13.4619 4.17525 14.6471 5.625 14.6471C6.58074 14.6471 7.41719 14.132 7.87626 13.3621M7.87626 10.6379C8.11354 11.0358 8.25 11.5018 8.25 12C8.25 12.4982 8.11354 12.9642 7.87626 13.3621M7.87626 10.6379L13.8737 7.00916M7.87626 13.3621L13.8737 16.9908M13.8737 16.9908C13.6365 17.3888 13.5 17.8548 13.5 18.3529C13.5 19.8149 14.6753 21 16.125 21C17.5747 21 18.75 19.8149 18.75 18.3529C18.75 16.891 17.5747 15.7059 16.125 15.7059C15.1693 15.7059 14.3328 16.221 13.8737 16.9908ZM13.8737 7.00916C14.3328 7.77905 15.1693 8.29412 16.125 8.29412C17.5747 8.29412 18.75 7.10899 18.75 5.64706C18.75 4.18513 17.5747 3 16.125 3C14.6753 3 13.5 4.18513 13.5 5.64706C13.5 6.14521 13.6365 6.61123 13.8737 7.00916Z",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
};
export default SvgScShare;